<div class="card mb-5">
	<div class="card-header">
		<h3>Histórico de Cierres de Cajas por Destino</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col form-group">
				<label for="startDate" class="form-label">Fecha Inicio</label>
				<input type="date" name="startDate" id="startDate" (change)="refreshTables()" [(ngModel)]="startDate"
					class="form-control">
			</div>
			<div class="col form-group">
				<label for="endDate" class="form-label">Fecha Fin</label>
				<input type="date" name="endDate" id="endDate" (change)="refreshTables()" [(ngModel)]="endDate"
					class="form-control">
			</div>
		</div>
		<div class="table-responsive mt-3">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle">
						<th>Bodega</th>
						<th>Venta</th>
						<th>Credito</th>
						<th>Recuperación</th>
						<th>Gastos</th>
						<th>Liquidación</th>
						<th>Cobaca</th>
						<th>Maya</th>
						<th>Cooperativa</th>
						<th>Efectivo</th>
						<th>Diferencia</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let general of data; let i = index">
						<tr style="font-size: 1.1em;" class="tr-middle">
							<td>
								{{general.warehouseName}}
								<i [ngClass]="showing['w'+general.warehouse]?'fa-eye-slash':'fa-eye'"
									class="clickeable fa text-info" (click)="gettingDetailDays(general)"></i>
							</td>
							<td>{{general.sale | currency:'Q'}}</td>
							<td>{{general.credit | currency:'Q'}}</td>
							<td>{{general.recovery | currency:'Q'}}</td>
							<td>{{general.expense | currency:'Q'}}</td>
							<td>{{general.settlement | currency:'Q'}}</td>
							<td>{{general.cobaca | currency:'Q'}}</td>
							<td>{{general.maya | currency:'Q'}}</td>
							<td>{{general.cooperative | currency:'Q'}}</td>
							<td>{{general.cash | currency:'Q'}}</td>
							<td>{{general.difference | currency:'Q'}}</td>
						</tr>
						<tr class="tr-middle" *ngIf="showing['w'+general.warehouse] && general.days">
							<td colspan="11" style="padding: 1em; background-color: skyblue;">
								<table class="table" style="margin: 0;">
									<thead>
										<tr class="tr-middle">
											<th colspan="12" class="th-relative">
												<span class="h3"><i class="fa fa-calendar-days"></i>INTERVALOS DE DÍAS</span>
												<div class="th-absolute-div">
													<i [ngClass]="general.showDays?'fa-eye-slash':'fa-eye'"
														class="fa clickeable text-info"
														(click)="general.showDays = !general.showDays"></i>
												</div>
											</th>
										</tr>
										<tr class="tr-middle" *ngIf="general.showDays">
											<th>Intervalo</th>
											<th>Venta</th>
											<th>Credito</th>
											<th>Recuperación</th>
											<th>Gastos</th>
											<th>Liquidación</th>
											<th>Cobaca</th>
											<th>Maya</th>
											<th>Cooperativa</th>
											<th>Efectivo</th>
											<th>Diferencia</th>
										</tr>
									</thead>
									<tbody *ngIf="general.showDays">
										<ng-container *ngFor="let day of general.days; let j = index">
											<tr class="tr-middle second-table"
												[class.without-border]="showing['d' + day.id]">
												<td>
													{{day.day}}
												</td>
												<td>
													{{day.sale | currency:'Q'}}  
													<i
														class="fa clickeable text-info me-2"
														[ngClass]="showing['p' + day.id] ? 'fa-eye-slash' : 'fa-eye'"
														(click)="toggleProducts(day)"
														title="Ver productos del intervalo"
													></i>
												</td>
												<td>
													{{day.credit | currency:'Q'}}
													<i
														class="fa clickeable text-info ms-2"
														[ngClass]="showing['c' + day.id] ? 'fa-eye-slash' : 'fa-eye'"
														(click)="toggleCredit(day)"
														title="Ver facturas al crédito"
													></i>
												</td>
												<td>
													{{day.recovery | currency:'Q'}}
													<i
														class="fa clickeable text-info ms-2"
														[ngClass]="showing['r' + day.id] ? 'fa-eye-slash' : 'fa-eye'"
														(click)="toggleRecovery(day)"
														title="Ver detalle de recuperación (agrupado)"
													></i>
												</td>
												<td>
													{{day.expense | currency:'Q'}}
													<i
														class="fa clickeable text-info ms-2"
														[ngClass]="showing['e_' + day.id] ? 'fa-eye-slash' : 'fa-eye'"
														(click)="toggleExpenses(day)"
														title="Ver detalle de gastos"
													></i>
												</td>
												<td>{{day.settlement | currency:'Q'}}</td>
												<td>
													{{day.cobaca | currency:'Q'}}
													<i
														class="fa clickeable text-info ms-2"
														[ngClass]="showing['bt_' + day.id + '_1'] ? 'fa-eye-slash' : 'fa-eye'"
														(click)="toggleBankTransfer(day, 1)"
														title="Ver detalle Cobaca"
													></i>
												</td>

												<td>
													{{day.maya | currency:'Q'}}
													<i
														class="fa clickeable text-info ms-2"
														[ngClass]="showing['bt_' + day.id + '_2'] ? 'fa-eye-slash' : 'fa-eye'"
														(click)="toggleBankTransfer(day, 2)"
														title="Ver detalle Maya"
													></i>
												</td>

												<td>
													{{day.cooperative | currency:'Q'}}
													<i
														class="fa clickeable text-info ms-2"
														[ngClass]="showing['bt_' + day.id + '_3'] ? 'fa-eye-slash' : 'fa-eye'"
														(click)="toggleBankTransfer(day, 3)"
														title="Ver detalle Cooperativa"
													></i>
												</td>
												<td>{{day.cash | currency:'Q'}}</td>
												<td>{{day.difference | currency:'Q'}}</td>
											</tr>
											<tr class="tr-middle second-table" *ngIf="showing['bt_' + day.id + '_1']">
												<td colspan="12" style="padding: 1em; background: #eef7ff;">
													<div class="d-flex align-items-center mb-2">
													<i class="fa fa-building-columns me-2 text-primary"></i>
													<strong class="text-uppercase">COBACA</strong>
													</div>

													<div *ngIf="loadingBankTransfer['bt_' + day.id + '_1']" class="d-flex align-items-center">
													<strong role="status">Cargando Cobaca...</strong>
													<div class="spinner-border ms-auto" aria-hidden="true"></div>
													</div>

													<ng-container *ngIf="!loadingBankTransfer['bt_' + day.id + '_1']">
													<ng-container *ngIf="day.bankTransfersCobaca?.length > 0; else noCobaca">
														<table class="table table-sm table-bordered mb-0">
														<thead>
															<tr class="tr-middle">
																<th>Banco</th>
																<th>Cuenta</th>
																<th>Doc</th>
																<th>Fecha</th>
																<th class="text-right">Monto</th>
																<th class="text-center">Acciones</th>
															</tr>
														</thead>
														<tbody>
															<tr class="tr-middle" *ngFor="let t of day.bankTransfersCobaca">
																<td>{{t.bank ?? ''}}</td>
																<td>{{t.accountNumber ?? ''}}</td>
																<td>{{t.bankAccountTransfer?.documentFrom ?? ''}}</td>
																<td>{{t.bankAccountTransfer?.date | date:'yyyy-MM-dd'}}</td>
																<td class="text-rigth">{{ (t.bankAccountTransfer?.amount ?? 0) | currency:'Q' }}</td>
																<td>
																	<div
																	style="display: flex; justify-content: space-evenly;
																	"
																	>
																		<span *ngIf="t.canDelete" (click)="deleteBankTranfer(t, 1, day)" title="Eliminar Transferencia"
																				class="clickeable text-danger">
																				<i *ngIf="!loadingBankTransferDelete[t.bankAccountTransfer.id]" class="fa fa-trash"></i>
																				<span *ngIf="loadingBankTransferDelete[t.bankAccountTransfer.id]"
																					class="spinner-border spinner-border-sm" aria-hidden="true"></span>
																		</span>
																	</div>
																</td>
															</tr>
														</tbody>
														</table>
													</ng-container>

													<ng-template #noCobaca>
														<span class="display-6">
														<i class="fa fa-circle-info"></i> No hay transferencias Cobaca
														</span>
													</ng-template>
													</ng-container>
												</td>
											</tr>
											<tr class="tr-middle second-table" *ngIf="showing['bt_' + day.id + '_2']">
												<td colspan="12" style="padding: 1em; background: #f5fff2;">
													<div class="d-flex align-items-center mb-2">
													<i class="fa fa-building-columns me-2 text-success"></i>
													<strong class="text-uppercase">MAYA</strong>
													</div>

													<div *ngIf="loadingBankTransfer['bt_' + day.id + '_2']" class="d-flex align-items-center">
													<strong role="status">Cargando Maya...</strong>
													<div class="spinner-border ms-auto" aria-hidden="true"></div>
													</div>

													<ng-container *ngIf="!loadingBankTransfer['bt_' + day.id + '_2']">
													<ng-container *ngIf="day.bankTransfersMaya?.length > 0; else noMaya">
														<table class="table table-sm table-bordered mb-0">
														<thead>
															<tr class="tr-middle">
																<th>Banco</th>
																<th>Cuenta</th>
																<th>Doc</th>
																<th>Fecha</th>
																<th class="text-right">Monto</th>
																<th class="text-center">Acciones</th>
															</tr>
														</thead>
														<tbody>
															<tr class="tr-middle" *ngFor="let t of day.bankTransfersMaya">
																<td>{{t.bank ?? ''}}</td>
																<td>{{t.accountNumber ?? ''}}</td>
																<td>{{t.bankAccountTransfer?.documentFrom ?? ''}}</td>
																<td>{{t.bankAccountTransfer?.date | date:'yyyy-MM-dd'}}</td>
																<td class="text-rigth">{{ (t.bankAccountTransfer?.amount ?? 0) | currency:'Q' }}</td>
																<td>
																	<div
																	style="display: flex; justify-content: space-evenly;
																	"
																	>
																		<span *ngIf="t.canDelete" (click)="deleteBankTranfer(t, 2, day)" title="Eliminar Transferencia"
																				class="clickeable text-danger">
																				<i *ngIf="!loadingBankTransferDelete[t.bankAccountTransfer.id]" class="fa fa-trash"></i>
																				<span *ngIf="loadingBankTransferDelete[t.bankAccountTransfer.id]"
																					class="spinner-border spinner-border-sm" aria-hidden="true"></span>
																		</span>
																	</div>
																</td>
															</tr>
														</tbody>
														</table>
													</ng-container>

													<ng-template #noMaya>
														<span class="display-6">
														<i class="fa fa-circle-info"></i> No hay transferencias Maya
														</span>
													</ng-template>
													</ng-container>
												</td>
											</tr>
											<tr class="tr-middle second-table" *ngIf="showing['bt_' + day.id + '_3']">
												<td colspan="12" style="padding: 1em; background: #f4f8ff;">
													<div class="d-flex align-items-center mb-2">
														<i class="fa fa-building-columns me-2 text-info"></i>
														<strong class="text-uppercase">COOPERATIVA</strong>
													</div>

													<div *ngIf="loadingBankTransfer['bt_' + day.id + '_3']" class="d-flex align-items-center">
														<strong role="status">Cargando Cooperativa...</strong>
														<div class="spinner-border ms-auto" aria-hidden="true"></div>
													</div>

													<ng-container *ngIf="!loadingBankTransfer['bt_' + day.id + '_3']">
														<ng-container *ngIf="day.bankTransfersCooperative?.length > 0; else noCooperative">
															<table class="table table-sm table-bordered mb-0">
																<thead>
																	<tr class="tr-middle">
																		<th>Banco</th>
																		<th>Cuenta</th>
																		<th>Doc</th>
																		<th>Fecha</th>
																		<th class="text-right">Monto</th>
																		<th class="text-center">Acciones</th>
																	</tr>
																</thead>
																<tbody>
																	<tr class="tr-middle" *ngFor="let t of day.bankTransfersCooperative">
																		<td>{{t.bank ?? ''}}</td>
																		<td>{{t.accountNumber ?? ''}}</td>
																		<td>{{t.bankAccountTransfer?.documentFrom ?? ''}}</td>
																		<td>{{t.bankAccountTransfer?.date | date:'yyyy-MM-dd'}}</td>
																		<td class="text-rigth">{{ (t.bankAccountTransfer?.amount ?? 0) | currency:'Q' }}</td>
																		<td>
																			<div style="display: flex; justify-content: space-evenly;">
																				<span *ngIf="t.canDelete"
																					(click)="deleteBankTranfer(t, 3, day)"
																					title="Eliminar Transferencia"
																					class="clickeable text-danger">
																					<i *ngIf="!loadingBankTransferDelete[t.bankAccountTransfer.id]" class="fa fa-trash"></i>
																					<span *ngIf="loadingBankTransferDelete[t.bankAccountTransfer.id]"
																						class="spinner-border spinner-border-sm" aria-hidden="true"></span>
																				</span>
																			</div>
																		</td>
																	</tr>
																</tbody>
															</table>
														</ng-container>

														<ng-template #noCooperative>
															<span class="display-6">
																<i class="fa fa-circle-info"></i> No hay transferencias Cooperativa
															</span>
														</ng-template>
													</ng-container>
												</td>
											</tr>


											<tr class="tr-middle second-table" *ngIf="showing['c' + day.id]">
												<td colspan="12" style="padding: 1em; background: #fff7e6;">
													<div class="d-flex align-items-center mb-2">
														<i class="fa fa-file-invoice-dollar me-2 text-warning"></i>
														<strong class="text-uppercase">CREDITO</strong>
													</div>

													<div *ngIf="loadingCredit[day.id]" class="d-flex align-items-center">
													<strong role="status">Cargando crédito...</strong>
													<div class="spinner-border ms-auto" aria-hidden="true"></div>
													</div>

													<ng-container *ngIf="!loadingCredit[day.id]">
													<ng-container *ngIf="day.creditInvoices?.length > 0; else noCredit">
														<table class="table table-sm table-bordered mb-0">
														<thead>
															<tr class="tr-middle">
															<th>Serie</th>
															<th>Número</th>
															<th>NIT</th>
															<th>Nombre</th>
															<th class="text-end">Total</th>
															</tr>
														</thead>
														<tbody>
															<tr class="tr-middle" *ngFor="let inv of day.creditInvoices">
															<td>{{inv.series}}</td>
															<td>{{inv.number}}</td>
															<td>{{inv.nit}}</td>
															<td>{{inv.name}}</td>
															<td class="text-end">{{inv.total | currency:'Q'}}</td>
															</tr>
														</tbody>
														</table>
													</ng-container>

													<ng-template #noCredit>
														<span class="display-6">
														<i class="fa fa-circle-info"></i> No hay facturas al crédito para este intervalo
														</span>
													</ng-template>
													</ng-container>
												</td>
											</tr>
											<tr class="tr-middle second-table" *ngIf="showing['r' + day.id]">
												<td colspan="12" style="padding: 1em; background: #f2fbff;">
													<div class="d-flex align-items-center mb-2">
														<i class="fa fa-hand-holding-dollar me-2 text-info"></i>
														<strong class="text-uppercase">RECUPERACIÓN</strong>
													</div>
													<div *ngIf="loadingRecovery[day.id]" class="d-flex align-items-center">
													<strong role="status">Cargando recuperación...</strong>
													<div class="spinner-border ms-auto" aria-hidden="true"></div>
													</div>

													<ng-container *ngIf="!loadingRecovery[day.id]">
													<ng-container *ngIf="day.recoveryGroups?.length > 0; else noRecovery">
														<table class="table table-sm table-bordered mb-0">
														<thead>
															<tr class="tr-middle">
															<th>Serie</th>
															<th>Cliente</th>
															<th class="text-end">Total (suma)</th>
															<th style="width: 40px;"></th>
															</tr>
														</thead>

														<tbody>
															<ng-container *ngFor="let g of day.recoveryGroups">
															<tr class="tr-middle">
																<td>{{g.series}}</td>
																<td>
																	<div><strong>{{ g.clientName || '' }}</strong></div>
																	<small class="text-muted">
																		Código: {{ g.clientCode || '' }} | NIT: {{ g.clientNit || '' }}
																	</small>
																</td>
																<td class="text-end">{{g.total | currency:'Q'}}</td>
																<td class="text-center">
																<i
																	class="fa clickeable text-info"
																	[ngClass]="showing['rg_' + day.id + '_' + g.external + '_' + g.series + '_' + g.document] ? 'fa-eye-slash' : 'fa-eye'"
																	(click)="toggleRecoveryGroup(day, g)"
																	title="Ver detalle del grupo"
																></i>
																</td>
															</tr>

															<tr *ngIf="showing['rg_' + day.id + '_' + g.external + '_' + g.series + '_' + g.document]">
																<td colspan="5" style="padding: 0.75em; background: #ffffff;">
																<table class="table table-sm table-bordered mb-0">
																	<thead>
																	<tr class="tr-middle">
																		<th>Factura</th>
																		<th>Fecha</th>
																		<th class="text-end">Monto</th>
																	</tr>
																	</thead>
																	<tbody>
																	<tr class="tr-middle" *ngFor="let r of g.rows">
																		<td>{{r.invoiceNumber}}</td>
																		<td>{{r.date | date:'yyyy-MM-dd'}}</td>
																		<td class="text-end">{{r.amount | currency:'Q'}}</td>
																	</tr>
																	</tbody>
																</table>
																</td>
															</tr>

															</ng-container>
														</tbody>
														</table>
													</ng-container>

													<ng-template #noRecovery>
														<span class="display-6">
														<i class="fa fa-circle-info"></i> No hay recuperación para este intervalo
														</span>
													</ng-template>
													</ng-container>
												</td>
												</tr>

											<tr class="tr-middle second-table" *ngIf="showing['p' + day.id]">
												<td colspan="12" style="padding: 1em; background: #e8f6ff;">
													<div class="d-flex align-items-center mb-2">
														<i class="fa fa-boxes-stacked me-2 text-primary"></i>
														<strong class="text-uppercase">VENTA</strong>
													</div>
													<div *ngIf="loadingProducts[day.id]" class="d-flex align-items-center">
													<strong role="status">Cargando productos...</strong>
													<div class="spinner-border ms-auto" aria-hidden="true"></div>
													</div>
													<ng-container *ngIf="!loadingProducts[day.id]">
													<ng-container *ngIf="day.products?.length > 0; else noProducts">
														<table class="table table-sm table-bordered mb-0">
														<thead>
															<tr class="tr-middle">
															<th>Producto</th>
															<th class="text-end">Entrante</th>
															<th class="text-end">Vendido</th>
															<th class="text-end">Regresado</th>
															<th></th>
															</tr>
														</thead>
														<tbody>
															<ng-container *ngFor="let p of day.products">
																<tr class="tr-middle">
																<td>{{p.productName}}</td>
																<td class="text-end">{{p.quantityEntering}}</td>
																<td class="text-end">{{p.quantitySold}}</td>
																<td class="text-end">{{p.quantityReturned}}</td>
																<td class="text-center">
																	<i
																	class="fa clickeable text-info"
																	[ngClass]="showing['i_' + day.id + '_' + p.productId] ? 'fa-eye-slash' : 'fa-eye'"
																	(click)="toggleInvoices(day, p)"
																	title="Ver facturas de este producto"
																	></i>
																</td>
																</tr>
																<tr *ngIf="showing['i_' + day.id + '_' + p.productId]">
																<td colspan="5" style="padding: 0.75em; background: #f7fbff;">
																	<div *ngIf="loadingInvoices['i_' + day.id + '_' + p.productId]" class="d-flex align-items-center">
																	<strong role="status">Cargando facturas...</strong>
																	<div class="spinner-border ms-auto" aria-hidden="true"></div>
																	</div>
																	<ng-container *ngIf="!loadingInvoices['i_' + day.id + '_' + p.productId]">
																	<ng-container *ngIf="p.invoices?.length > 0; else noInvoices">
																		<table class="table table-sm table-bordered mb-0">
																		<thead>
																			<tr class="tr-middle">
																			<th>Serie</th>
																			<th>Número</th>
																			<th>NIT</th>
																			<th>Nombre</th>
																			<th>Cantidad</th>
																			<th class="text-end">Total</th>
																			</tr>
																		</thead>
																		<tbody>
																			<tr class="tr-middle" *ngFor="let inv of p.invoices">
																			<td>{{inv.series}}</td>
																			<td>{{inv.number}}</td>
																			<td>{{inv.clientNit}}</td>
																			<td>{{inv.clientName}}</td>
																			<td>{{inv.quantity}}</td>
																			<td class="text-end">{{inv.total | currency:'Q'}}</td>
																			</tr>
																		</tbody>
																		</table>
																	</ng-container>

																	<ng-template #noInvoices>
																		<span class="display-6">
																		<i class="fa fa-circle-info"></i> No hay facturas para este producto
																		</span>
																	</ng-template>
																	</ng-container>
																</td>
																</tr>
															</ng-container>
															</tbody>
														</table>
													</ng-container>

													<ng-template #noProducts>
														<span class="display-6">
														<i class="fa fa-circle-info"></i> No hay productos para este intervalo
														</span>
													</ng-template>
													</ng-container>
												</td>
											</tr>

											<tr class="tr-middle second-table" *ngIf="showing['e_' + day.id]">
												<td colspan="12" style="padding: 1em; background: #fff5f2;">
													<div class="d-flex align-items-center mb-2">
														<i class="fa fa-money-bill me-2 text-danger"></i>
														<strong class="text-uppercase">GASTOS</strong>
													</div>
													<div *ngIf="loadingExpenses[day.id]" class="d-flex align-items-center">
													<strong role="status">Cargando productos...</strong>
													<div class="spinner-border ms-auto" aria-hidden="true"></div>
													</div>

													<ng-container *ngIf="!loadingExpenses[day.id]">
													<ng-container *ngIf="day.expenses?.length > 0; else noExpenses">
														<table class="table table-sm table-bordered mb-0">
														<thead>
															<tr class="tr-middle">
																<th>Proveedor</th>
																<th>Documento</th>
																<th>Descripcion</th>
																<th class="text-end">Total</th>
															</tr>
														</thead>

														<tbody>
															<ng-container *ngFor="let g of day.expenses">
															<tr class="tr-middle">
																<td>{{g.clientName}}</td>
																<td>{{g.expenseDocument.sDoc}} - {{g.expenseDocument.noDoc}}</td>
																<td>{{g.expenseDocument.desc}}</td>
																<td class="text-end">{{g.expenseDocument.tdoc | currency:'Q'}}</td>
															</tr>
															</ng-container>
														</tbody>
														</table>
													</ng-container>

													<ng-template #noExpenses>
														<span class="display-6">
														<i class="fa fa-circle-info"></i> No hay gastos para este intervalo
														</span>
													</ng-template>
													</ng-container>
												</td>
											</tr>

										</ng-container>
									</tbody>
								</table>
							</td>
						</tr>
					</ng-container>
					<tr class="tr-middle" *ngIf="data.length == 0 && got">
						<td colspan="7" style="font-size: 1.5em;">
							<i class="fa fa-circle-info"></i>No se encontraron resultados
						</td>
					</tr>
					<tr class="tr-middle" *ngIf="!got">
						<td colspan="7" style="padding: 2em;">
							<div class="d-flex align-items-center">
								<strong role="status">Cargando...</strong>
								<div class="spinner-border ms-auto" aria-hidden="true"></div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>